import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SettingsClientCredentialsAddEditRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsClientCredentialsAddEdit', {
		url: '/admin/credentials/:id/edit',
		controllerAs: 'vm',
		controller: SettingsClientCredentialsAddEditCtrl,
		templateUrl: '/ng/hub/Settings/ClientCredentials/AddEdit/SettingsClientCredentialsAddEditCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'Client Credentials Add/Edit',
		},
	});
}

export class SettingsClientCredentialsAddEditCtrl {
	constructor(Api, modal, $stateParams) {
		'ngInject';
		this.Api = Api;
		this.modal = modal;
		this.record = {};
		this.editing = false;
		if ($stateParams.id) {
			this.editing = true;
			this.Api.get(`/credentials/${$stateParams.id}`).then(resp => {
				this.record = resp;
			});
		}
		this.isSaving = false;
	}

	save() {
		let endpoint, verb;
		if (this.editing) {
			endpoint = `/credentials/${this.record.id}`;
			verb = 'PATCH';
		} else {
			endpoint = '/credentials';
			verb = 'POST';
		}
		const data = {
			client_id: this.record.client_id,
			is_active: this.record.is_active,
			type: this.record.type,
			username: this.record.username,
			values: this.record.values,
		};
		try {
			data.metadata = this.record.metadata ? JSON.parse(this.record.metadata) : {};
		} catch (err) {
			alert('Unable to parse metadata into JSON. The metadata value should be a string that represents valid JSON.');
			return;
		}
		this.isSaving = true;
		this.Api.request(verb, endpoint, data).then(resp => {
			this.isSaving = false;
			if (resp.status == 204) {
				this.modal.resolveByTitle('Edit');
			} else {
				alert('Update failed');
			}
		});
	}
}
